import React from 'react';
import PropTypes from 'prop-types';

import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Skeleton from '@mui/material/Skeleton';
import { makeStyles } from '@mui/styles';

import SwitchCustom from '../../../Switch/SwitchCustom';

const useStyles = makeStyles(() => ({
    skeleton: {
        borderRadius: '2px',
        margin: '5px'
    },
    cricleSkeleton: {
        borderRadius: '999px',
        margin: '5px'
    }
}));

const AdminRows = ({ id, name, ruleType, handleSwitch, loading }) => {
    const classes = useStyles();
    return (
        <TableRow key={id}>
            <TableCell component="th" scope="row">
                {loading ? <Skeleton className={classes.skeleton} height={30} /> : name}
            </TableCell>
            {ruleType?.map(element => <TableCell key={element.id} align="left">
                {loading ? <Skeleton className={classes.cricleSkeleton} variant="circle" width={30} height={30} />
                : <SwitchCustom
                    switchStatus={element.status}
                    handleSwitch={checked => handleSwitch(name, element.type, checked)}
                />}
            </TableCell>
            )}
        </TableRow>
    );
}

AdminRows.propTypes = {
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    ruleType: PropTypes.array.isRequired,
    handleSwitch: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired
};

export default AdminRows